import { AxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  RawAnalysisResponse,
  CreateAnalysisOrderPayload,
  RawAnalysisOrderResponse,
  AnalysisResultsResponse,
} from './AnalysisTypes';
import { ErrorResponse } from 'store/ReduxTypes';
import { api } from '@utils/api';

/* ───────── GET /analysis-recommendations/latest ───────── */
export const getLatestAnalysisRecommendations = createAsyncThunk<
  RawAnalysisResponse,
  void,
  { rejectValue: ErrorResponse }
>('analysis/getLatest', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get<RawAnalysisResponse>('/analysis-recommendations/latest');

    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message, status: e.response?.status });
  }
});

/* ───────── POST /analysis-recommendations ───────── */
export const requestAnalysisRecommendations = createAsyncThunk<
  RawAnalysisResponse,
  void,
  { rejectValue: ErrorResponse }
>('analysis/requestRecommendations', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.post<RawAnalysisResponse>('/analysis-recommendations', {});
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ───────── GET /analysis-recommendations/{request_id} ───────── */
export const getAnalysisRecommendationsStatus = createAsyncThunk<
  RawAnalysisResponse,
  number,
  { rejectValue: ErrorResponse }
>('analysis/getRecommendationsStatus', async (requestId, { rejectWithValue }) => {
  try {
    const { data } = await api.get<RawAnalysisResponse>(`/analysis-recommendations/${requestId}`);
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ───────── POST /analysis-orders ───────── */
export const createAnalysisOrder = createAsyncThunk<
  RawAnalysisOrderResponse,
  CreateAnalysisOrderPayload,
  { rejectValue: ErrorResponse }
>('analysis/createOrder', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await api.post<RawAnalysisOrderResponse>('/analysis-orders', payload);
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ───────── GET /analysis-orders/{id}/results ───────── */
export const getAnalysisResults = createAsyncThunk<
  AnalysisResultsResponse,
  number, // orderId
  { rejectValue: ErrorResponse }
>('analysis/getResults', async (orderId, { rejectWithValue }) => {
  try {
    const { data } = await api.get<AnalysisResultsResponse>(`/analysis-orders/${orderId}/results`);
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});
